import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
export const Section = forwardRef(function SectionComponent({ children, testId, hasDivider = true, id, hasPaddingRight = true, BoxProps, DividerBoxProps, unsafeClassname, display = "block", hideSection = false, }, ref) {
    if (hideSection)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { ref: ref, as: "section", id: id, testId: testId, unsafe_className: `Section ${unsafeClassname !== null && unsafeClassname !== void 0 ? unsafeClassname : ""}`, display: display, children: _jsx(Box, Object.assign({ paddingRight: {
                        "breakpoint.base": hasPaddingRight
                            ? "spacing.16"
                            : "spacing.none",
                        "breakpoint.sm": hasPaddingRight ? "spacing.32" : "spacing.none",
                        "breakpoint.lg": "spacing.none",
                    }, paddingLeft: {
                        "breakpoint.base": "spacing.16",
                        "breakpoint.sm": "spacing.32",
                        "breakpoint.lg": "spacing.none",
                    } }, BoxProps, { children: children })) }), hasDivider && display !== "none" && (_jsx(Box, Object.assign({ paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                } }, DividerBoxProps, { children: _jsx(Divider, { "aria-hidden": "true", marginVertical: {
                        "breakpoint.base": "spacing.24",
                        "breakpoint.lg": "spacing.32",
                    } }) })))] }));
});
